<template>
  <PVButton
    :label="label"
    :icon="icon"
    :iconPos="iconPosition"
    :severity="severity"
    :size="size"
    :outlined="variant === 'outlined'"
    :text="variant === 'text'"
    :plain="variant === 'plain'"
    :raised="variant === 'raised'"
    :rounded="rounded"
    :loading="loading"
    :disabled="disabled"
    :class="buttonClass"
    :style="buttonStyle"
    @click="handleClick"
  >
    <template v-if="$slots.default" #default>
      <slot />
    </template>
  </PVButton>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import type { SButtonProps } from '@/components/globals/SButton/SButton.types'

const props = withDefaults(defineProps<SButtonProps>(), {
  iconPosition: 'left',
  severity: 'primary',
  size: 'normal',
  variant: 'filled',
  rounded: false,
  loading: false,
  disabled: false,
})

// Computed
const buttonClass = computed(() => {
  const classes = []

  // Adiciona classes customizadas se fornecidas
  if (props.class) {
    if (typeof props.class === 'string') {
      classes.push(props.class)
    } else if (Array.isArray(props.class)) {
      classes.push(...props.class)
    } else {
      classes.push(props.class)
    }
  }

  return classes
})

const buttonStyle = computed(() => {
  if (typeof props.style === 'string') {
    return props.style
  }
  return props.style || {}
})

// Métodos
const handleClick = () => {
  if (!props.disabled && !props.loading) {
    props.onClick?.()
  }
}
</script>
